import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import Text from 'components/typography/Text/Text'
import Select from 'components/form/Select/Select'

import s from './Select.scss'


const ProfilePageSelect = ({
  className, valueLink, selectWrapperClassName, placeholder, type, label, options, onChange,
}) => (
  <div className={className}>
    <Text
      message={label}
      size="16-19"
      color="gray"
    />
    <Select
      className={cx(s.select, selectWrapperClassName)}
      {...{ valueLink, type, placeholder, placeholderClassName: s.placeholder, options, onChange }}
    />
  </div>
)

ProfilePageSelect.propTypes = {
  className: PropTypes.string,
}


export default React.memo(ProfilePageSelect)
